import { autoinject, PLATFORM, useView } from 'aurelia-framework';
import { Router, RouterConfiguration } from 'aurelia-router';
import { IDemoRouteConfig } from 'app/demo/lib/router-types';
import { DemoContentPageBase } from 'app/demo/pages/demo-content-page-base';


@autoinject()
@useView('./demo-content-page.html')
export class DemoComponentsPage extends DemoContentPageBase {

    ////****************** Fields and Properties ************************************////


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    protected async configureRouter(config: RouterConfiguration, router: Router): Promise<void> {
        const routes: IDemoRouteConfig[] = [
            { route: '', redirect: '#' }
        ];
        config.map(routes);

        config.mapUnknownRoutes(PLATFORM.moduleName('app/shared/components/not-found'));

        this.router = router;
    }

    ////****************** Service Calls ********************************************////

}
